
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { slicedToArray as _slicedToArray, defineProperty as _defineProperty, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { forwardRef, useReducer, useEffect, useImperativeHandle } from 'react';
import classNames from '../../../node_modules/classnames/index.js';
import { reducer } from './reducer.js';
import { tableContainer } from './styles.js';
import Body from './components/Body.js';
import Header from './components/Header.js';
import { Actions } from './constants.js';
import { createElement as jsx } from '../../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js';

var Table = function Table(props, ref) {
  var columns = props.columns,
    rows = props.rows,
    emptyState = props.emptyState,
    onRowSelect = props.onRowSelect,
    sorting = props.sorting,
    _props$id = props.id,
    id = _props$id === void 0 ? "table" : _props$id,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$className = props.className,
    className = _props$className === void 0 ? "" : _props$className;
  var _useReducer = useReducer(reducer, {
      columns: columns,
      rows: rows,
      emptyState: emptyState,
      sorting: sorting,
      selected: []
    }),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  var selected = state.selected;
  useEffect(function () {
    dispatch({
      type: Actions.columnsChanged,
      payload: columns
    });
  }, [columns]);
  useEffect(function () {
    dispatch({
      type: Actions.rowsChanged,
      payload: rows
    });
  }, [rows]);
  useEffect(function () {
    if (!sorting) return;
    dispatch({
      type: Actions.sortingChanged,
      payload: sorting
    });
  }, [sorting]);
  useEffect(function () {
    onRowSelect === null || onRowSelect === void 0 || onRowSelect(selected);
  }, [selected]);
  useImperativeHandle(ref, function () {
    return {
      selectRowsById: function selectRowsById(rowIds) {
        return dispatch({
          type: Actions.selectMany,
          payload: rowIds
        });
      },
      resetSelected: function resetSelected() {
        return dispatch({
          type: Actions.resetSelectedRows,
          payload: null
        });
      }
    };
  });
  var containerClassNames = classNames(_defineProperty(_defineProperty({}, className, Boolean(className)), "disabled", disabled));
  return jsx("div", {
    css: tableContainer,
    "data-testid": id
  }, jsx("table", {
    className: containerClassNames
  }, jsx(Header, _extends({
    state: state,
    dispatch: dispatch
  }, props)), jsx(Body, _extends({
    state: state,
    dispatch: dispatch
  }, props))));
};
var Table$1 = /*#__PURE__*/forwardRef(Table);

export { Table$1 as default };
//# sourceMappingURL=Table.js.map
